module.exports = __webpack_public_path__ + "img/com (1).0c06c99a.png";